import alt from 'js/alt';

class ReportActions {
  updateAndShowLoadDetails(load) {
    return load;
  }

  toggleLayer(id, checked) {
    return { id: id, checked: checked };
  }

  closePopup() {
    return true;
  }

  buildReport() {
    return true;
  }

  reportLibrariesLoaded() {
    return true;
  }

  closeReportBuildPopup() {
    return true;
  }

  showReportBuildPopup(error = '') {
    return { error: error };
  }

  showLoadTimeoutPopup() {
    return true;
  }

  closeLoadTimeoutPopup() {
    return true;
  }

  showWindDataWarningPopup() {
    return true;
  }

  closeWindDataWarningPopup() {
    return true;
  }

  showSummary() {
    return true;
  }

  closeSummary() {
    return true;
  }

  togglePreloader(bool) {
    return bool;
  }
}

export const reportActions = alt.createActions(ReportActions);
